<template>
  <screen-tab-filter-control :label="label">
    <dynamic-combobox
      v-if="combobox"
      :inputs.sync="inputsModel"
      :search-input.sync="searchInput"
      :placeholder="placeholder"
    />
    <string-list-input
      v-else
      :inputs.sync="inputsModel"
      :placeholder="placeholder"
    />
  </screen-tab-filter-control>
</template>

<script>
import StringListInput from '@/components/Common/StringListInput';
import DynamicCombobox from '@/components/Common/DynamicCombobox';
import ScreenTabFilterControl from './ScreenTabFilterControl';

export default {
  name: 'ScreenTabFilterByMultipleValuesControl',
  components: {
    StringListInput,
    DynamicCombobox,
    ScreenTabFilterControl,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Enter value',
    },
    inputs: {
      type: Array,
      default: null,
    },
    combobox: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:inputs'],
  data: () => ({ searchInput: null }),
  computed: {
    inputsModel: {
      get: function () {
        return this.inputs;
      },
      set: function (value) {
        this.$emit(
          'update:inputs',
          value?.length ? value : undefined
        );
      },
    },
  },
};
</script>
